export default "__VITE_ASSET__w9QlydSU__"